import type { MsgDeskLoadingProps } from '@/deskUiSkeletons/Shared/SharedSurfaceContext'

export function MsgDeskLoading({ contract, label = 'Loading portal', className = '' }: MsgDeskLoadingProps) {
  return (
    <div
      data-md-contract={contract}
      className={`flex min-h-screen w-full items-center justify-center bg-white text-xs font-semibold uppercase tracking-[0.2em] text-blue-600 ${className}`}
      role="status"
      aria-live="polite"
    >
      {label}
    </div>
  )
}
